// export const containerStyle = {
//   minHeight: '100vh',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   background: 'var(--bg)', // השתמש ברקע מהגלובל במקום gradient
//   padding: '20px'
// };

// export const formWrapperStyle = {
//   background: 'var(--card)', // השתמש בצבע מהגלובל במקום white
//   padding: '40px',
//   borderRadius: '16px', // תואם לגלובל
//   boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
//   width: '100%',
//   maxWidth: '450px',
//   direction: 'rtl'
// };

// export const headerStyle = {
//   textAlign: 'center',
//   marginBottom: '10px'
// };

// export const titleStyle = {
//   margin: '0 0 5px 0',
//   color: '#ffffff', // צבע לבן לטקסט בכרטיס כהה
//   fontSize: '1.3rem'
// };

// export const subtitleStyle = {
//   margin: 0,
//   color: 'var(--text)', // השתמש בצבע מהגלובל
//   fontSize: '1rem'
// };

// export const errorMessageStyle = {
//   background: '#fee',
//   color: '#d63384',
//   padding: '12px',
//   borderRadius: '8px',
//   marginBottom: '20px',
//   textAlign: 'center',
//   border: '1px solid #f5c2c7'
// };

// export const successMessageStyle = {
//   background: '#d1e7dd',
//   color: '#0f5132',
//   padding: '12px',
//   borderRadius: '8px',
//   marginBottom: '20px',
//   textAlign: 'center',
//   border: '1px solid #a3cfbb'
// };

// export const fieldGroupStyle = {
//   marginBottom: '15px'
// };

// export const lastFieldGroupStyle = {
//   marginBottom: '25px'
// };

// export const labelStyle = {
//   display: 'block',
//   marginBottom: '5px',
//   color: '#ffffff', // צבע לבן ללייבלים
//   fontWeight: '500'
// };

// // הסגנון הבסיסי - זהה לגלובל!
// export const inputStyle = {
//   width: '100%',
//   padding: '10px',
//   borderRadius: '10px',
//   border: '1px solid #27415f',
//   background: '#0f2a46',
//   color: '#ffffff',
//   marginBottom: '5px',
//   fontSize: '1rem',
//   boxSizing: 'border-box',
//   transition: 'all 0.3s ease',
//   fontFamily: 'inherit'
// };

// // סגנון הסלקט - זהה לאינפוט + תוספות dropdown
// export const selectStyle = {
//   ...inputStyle, // כעת יכלול את כל הסגנונות מהאינפוט
//   cursor: 'pointer',
//   backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e")`,
//   backgroundRepeat: 'no-repeat',
//   backgroundPosition: 'left 12px center',
//   backgroundSize: '20px',
//   paddingLeft: '45px',
//   appearance: 'none',
//   '-webkit-appearance': 'none',
//   '-moz-appearance': 'none'
// };

// export const errorInputStyle = {
//   ...inputStyle,
//   borderColor: '#dc3545',
//   backgroundColor: '#2d1b1b'
// };

// export const fieldErrorStyle = {
//   color: '#ff6b6b',
//   fontSize: '0.8rem',
//   marginTop: '-5px',
//   marginBottom: '10px'
// };

// export const fieldSuccessStyle = {
//   color: 'var(--accent)', 
//   fontSize: '0.8rem',
//   marginTop: '-5px',
//   marginBottom: '10px'
// };

// export const validationMessageStyle = {
//   fontSize: '0.8rem',
//   marginTop: '5px'
// };

// export const submitButtonStyle = {
//   width: '100%',
//   padding: '14px',
//   color: '#0b1c2b', // תואם לגלובל
//   background: 'var(--accent)', // השתמש בצבע accent מהגלובל
//   border: 'none',
//   borderRadius: '16px', // תואם לגלובל
//   fontSize: '1rem',
//   fontWeight: '700', // תואם לגלובל
//   transition: 'all 0.3s ease',
//   marginBottom: '20px',
//   cursor: 'pointer'
// };

// export const getSubmitButtonBackground = (loading, idError, hasRequiredFields, isValidId) => {
//   return (loading || idError || !hasRequiredFields || !isValidId)
//     ? '#334455' // צבע כהה יותר כשלא זמין
//     : 'var(--accent)';
// };

// export const getSubmitButtonCursor = (loading, idError) => {
//   return (loading || idError) ? 'not-allowed' : 'pointer';
// };

// export const loginLinkContainerStyle = {
//   textAlign: 'center'
// };

// export const loginLinkStyle = {
//   color: 'var(--accent)', // השתמש בצבע accent מהגלובל
//   fontSize: '0.9rem',
//   cursor: 'pointer'
// };

// export const getLoginLinkOpacity = (loading) => loading ? 0.5 : 1;
// export const getLoginLinkCursor = (loading) => loading ? 'not-allowed' : 'pointer';

// // פונקציות עזר לאירועים - מעודכנות לצבעי הגלובל
// export const handleInputFocus = (e, hasError = false) => {
//   if (!hasError) {
//     e.target.style.borderColor = 'var(--accent)';
//     e.target.style.boxShadow = '0 0 0 3px rgba(187, 233, 243, 0.1)';
//   }
// };

// export const handleInputBlur = (e, hasError = false) => {
//   if (!hasError) {
//     e.target.style.borderColor = '#27415f';
//     e.target.style.boxShadow = 'none';
//   }
// };

// export const handleSelectFocus = (e) => {
//   e.target.style.borderColor = 'var(--accent)';
//   e.target.style.boxShadow = '0 0 0 3px rgba(187, 233, 243, 0.1)';
// };

// export const handleSelectBlur = (e) => {
//   e.target.style.borderColor = '#27415f';
//   e.target.style.boxShadow = 'none';
// };

// export const handleButtonHover = (e, canHover = true) => {
//   if (canHover) {
//     e.target.style.transform = 'translateY(-2px)';
//     e.target.style.boxShadow = '0 8px 25px rgba(187, 233, 243, 0.3)';
//   }
// };

// export const handleButtonLeave = (e, canHover = true) => {
//   if (canHover) {
//     e.target.style.transform = 'translateY(0px)';
//     e.target.style.boxShadow = 'none';
//   }
// };

// export const handleLinkHover = (e, canHover = true) => {
//   if (canHover) e.target.style.textDecoration = 'underline';
// };

// export const handleLinkLeave = (e) => {
//   e.target.style.textDecoration = 'none';
// };


// client/src/pages/UserRegister/styles.js
import styled, { keyframes } from 'styled-components';

// ========== Animations ==========
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

// ========== Layout ==========
export const PageContainer = styled.div`
  min-height: 100vh;
  background: #e1e1e1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  direction: rtl;
`;

export const FormCard = styled.div`
  background: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
  animation: ${fadeIn} 0.4s ease-out;
`;

export const FormHeader = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

export const IconWrapper = styled.div`
  width: 72px;
  height: 72px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  margin: 0 auto 20px;
`;

export const Title = styled.h1`
  color: #333;
  font-size: 1.8rem;
  margin: 0 0 8px;
  font-weight: 600;
`;

export const Subtitle = styled.p`
  color: #666;
  font-size: 0.95rem;
  margin: 0;
`;

// ========== Form Elements ==========
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
  
  span {
    color: #e74c3c;
    margin-right: 4px;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 14px 16px;
  border: 2px solid ${props => props.hasError ? '#e74c3c' : '#e9ecef'};
  border-radius: 8px;
  background: ${props => props.hasError ? '#fff5f5' : '#f8f9fa'};
  color: #333;
  font-size: 1rem;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${props => props.hasError ? '#e74c3c' : '#667eea'};
    background: white;
    box-shadow: 0 0 0 3px ${props => props.hasError ? 'rgba(231, 76, 60, 0.1)' : 'rgba(102, 126, 234, 0.1)'};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &::placeholder {
    color: #999;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 14px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #f8f9fa;
  color: #333;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: left 12px center;
  background-size: 20px;
  padding-left: 45px;

  &:focus {
    outline: none;
    border-color: #667eea;
    background-color: white;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

// ========== Validation Messages ==========
export const FieldError = styled.div`
  color: #e74c3c;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const FieldSuccess = styled.div`
  color: #27ae60;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const FieldHint = styled.div`
  color: #f39c12;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
`;

// ========== Alerts ==========
export const Alert = styled.div`
  padding: 14px 18px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.9rem;
  animation: ${fadeIn} 0.3s ease-out;

  ${props => props.type === 'error' && `
    background: #fee2e2;
    color: #991b1b;
    border: 1px solid #fecaca;
  `}

  ${props => props.type === 'success' && `
    background: #d1fae5;
    color: #065f46;
    border: 1px solid #a7f3d0;
  `}
`;

export const AlertIcon = styled.span`
  font-size: 1.2rem;
`;

// ========== Button ==========
export const SubmitButton = styled.button`
  width: 100%;
  padding: 14px 24px;
  background: ${props => props.disabled 
    ? '#ccc' 
    : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;

export const Spinner = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

// ========== Links ==========
export const LinksContainer = styled.div`
  text-align: center;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledLink = styled.span`
  color: ${props => props.highlight ? '#f39c12' : '#667eea'};
  font-size: 0.9rem;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.5 : 1};
  transition: all 0.2s;

  &:hover {
    color: ${props => props.highlight ? '#e67e22' : '#764ba2'};
    text-decoration: underline;
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 8px 0;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e9ecef;
  }

  span {
    color: #999;
    font-size: 0.85rem;
  }
`;

// ========== Loading State ==========
export const LoadingContainer = styled.div`
  text-align: center;
  padding: 60px 20px;
`;

export const LoadingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e9ecef;
  border-top-color: #667eea;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto 20px;
`;

export const LoadingText = styled.p`
  color: #666;
  font-size: 1rem;
  margin: 0;
`;

// ========== Password Strength ==========
export const PasswordStrength = styled.div`
  display: flex;
  gap: 4px;
  margin-top: 8px;
`;

export const StrengthBar = styled.div`
  flex: 1;
  height: 4px;
  border-radius: 2px;
  background: ${props => {
    if (!props.active) return '#e9ecef';
    if (props.strength === 'weak') return '#e74c3c';
    if (props.strength === 'medium') return '#f39c12';
    return '#27ae60';
  }};
  transition: background 0.3s ease;
`;

export const StrengthText = styled.span`
  font-size: 0.75rem;
  color: ${props => {
    if (props.strength === 'weak') return '#e74c3c';
    if (props.strength === 'medium') return '#f39c12';
    return '#27ae60';
  }};
`;

// ========== Two Column Layout (for larger forms) ==========
export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;